import { Fragment } from 'react';
import { Dialog, Disclosure, Transition } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import STATE_CAPITALS from '../utils/STATE_CAPITALS';
import React, { useState, useRef, useEffect, useMemo } from 'react';
import Auth from '../utils/auth'; // Import Auth
import SearchArea from './SearchArea';
import GpsAddressSearch from './GpsAddressSearch';
import GpsCoordinateSearch from './GpsCoordinateSearch';
import '../App.css';
import * as mgrs from 'mgrs';
import QRCode from 'react-qr-code';
import QrShareActions from './QrShareActions';
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const Footer = (props) => {};

const HeaderOptions = (props) => {
  if (Auth.loggedIn()) {
    return (
      <>
        <a onClick={() => props.getLocation()} className="text-sm font-semibold leading-7 text-gray-900">
          Go to Me
        </a>
        <a onClick={() => props.setIsPostPaneOpen(true)} className="text-sm font-semibold leading-7 text-gray-900">
          Report
        </a>
        {/* <a onClick={() => props.setIsVisiblePaneOpen(true)} className="text-sm font-semibold leading-7 text-gray-900">
          Visible
        </a> */}
        <a onClick={() => props.setIsProfilePaneOpen(true)} className="text-sm font-semibold leading-7 text-gray-900">
          Profile
        </a>
        <a onClick={() => Auth.logout()} className="text-sm font-semibold leading-7 text-gray-900">
          Log Out
        </a>
      </>
    );
  }
  return (
    <>
      <a onClick={() => props.getLocation()} className="text-sm font-semibold leading-7 text-gray-900">
        Go to Me
      </a>
      {/* <a onClick={() => props.setIsVisiblePaneOpen(true)} className="text-sm font-semibold leading-7 text-gray-900">
        Visible
      </a> */}
      <a onClick={() => props.setIsRegisterPaneOpen(true)} className="text-sm font-semibold leading-7 text-gray-900">
        Register
      </a>
      <a onClick={() => props.setIsLoginPaneOpen(true)} className="text-sm font-semibold leading-7 text-gray-900">
        Log In
      </a>
    </>
  );
};

const HeaderOptionsCollapsed = (props) => {
  if (Auth.loggedIn()) {
    return (
      <>
        <a
          onClick={() => {
            props.getLocation();
            props.setMobileMenuOpen(false);
          }}
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
        >
          Go to Me
        </a>
        <a
          onClick={() => {
            props.setMobileMenuOpen(false);
            props.setIsPostPaneOpen(true);
          }}
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
        >
          Report
        </a>
        {/* <a
          onClick={() => {
            props.setMobileMenuOpen(false);
            props.setIsVisiblePaneOpen(true);
          }}
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
        >
          Visible
        </a> */}
        <a
          onClick={() => {
            props.setMobileMenuOpen(false);
            props.setIsProfilePaneOpen(true);
          }}
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
        >
          Profile
        </a>
        <a
          onClick={() => {
            props.setMobileMenuOpen(false);
            Auth.logout();
          }}
          className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
        >
          Log Out
        </a>
      </>
    );
  }

  return (
    <>
      <a
        onClick={() => {
          props.getLocation();
          props.setMobileMenuOpen(false);
        }}
        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
      >
        Go to Me
      </a>
      {/* <a
        onClick={() => {
          props.setMobileMenuOpen(false);
          props.setIsVisiblePaneOpen(true);
        }}
        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
      >
        Visible
      </a> */}
      <a
        onClick={() => {
          props.setMobileMenuOpen(false);
          props.setIsProfilePaneOpen(true);
        }}
        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
      >
        Profile
      </a>
      <a
        onClick={() => {
          props.setMobileMenuOpen(false);
          props.setIsRegisterPaneOpen(true);
        }}
        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
      >
        Register
      </a>
      <a
        onClick={() => {
          props.setMobileMenuOpen(false);
          props.setIsLoginPaneOpen(true);
        }}
        className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
      >
        Log In
      </a>
    </>
  );
};

const Header = (props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [gpsOpen, setGpsOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [filterResetVersion, setFilterResetVersion] = useState(0);
  const [activeFilterSection, setActiveFilterSection] = useState('');
  const [quickRangeHours, setQuickRangeHours] = useState('');
  const [showGeoJSONAdvanced, setShowGeoJSONAdvanced] = useState(false);
  const [geoJSONFilterText, setGeoJSONFilterText] = useState('');
  const [geoJSONFilterError, setGeoJSONFilterError] = useState('');
  const [countryGeoJSONOptions, setCountryGeoJSONOptions] = useState([]);
  const [countryGeoJSONLoading, setCountryGeoJSONLoading] = useState(false);
  const [countryGeoJSONApplying, setCountryGeoJSONApplying] = useState(false);
  const [countryGeoJSONError, setCountryGeoJSONError] = useState('');
  const [selectedCountryGeoJSONId, setSelectedCountryGeoJSONId] = useState('');
  const [countryGeoJSONSubregionOptions, setCountryGeoJSONSubregionOptions] = useState([]);
  const [selectedCountryGeoJSONSubregionId, setSelectedCountryGeoJSONSubregionId] = useState('');
  const [countryGeoJSONSearchText, setCountryGeoJSONSearchText] = useState('');
  const [isCountrySearchFocused, setIsCountrySearchFocused] = useState(false);
  const countryFeatureCollectionCacheRef = useRef(new Map());
  const countrySubregionCacheRef = useRef(new Map());
  const countryApplyRequestRef = useRef(0);
  const lastAutoAppliedCountryIdRef = useRef('');
  const qrContainerRef = useRef(null);

  // GPS dropdown state (address search)
  const [geoLoading, setGeoLoading] = useState(false);

  // Landmarks
  const LANDMARK_GROUPS = [
    {
      label: "Core",
      items: [
        { label: "White House", lat: 38.897676, lon: -77.03653, zoom: 15.5 },
        { label: "U.S. Capitol", lat: 38.889939, lon: -77.009051, zoom: 15.5 },
        { label: "Supreme Court", lat: 38.890568, lon: -77.0044, zoom: 16 },
      ],
    },
    {
      label: "Departments",
      items: [
        { label: "Dept. of Defense (Pentagon)", lat: 38.87105, lon: -77.05596, zoom: 15 },
        { label: "Dept. of Justice", lat: 38.8946, lon: -77.0284, zoom: 16 },
        { label: "Dept. of Energy", lat: 38.8865, lon: -77.0220, zoom: 16 },
        { label: "Dept. of State", lat: 38.8951, lon: -77.0411, zoom: 16 },
        { label: "Dept. of Treasury", lat: 38.8990, lon: -77.0365, zoom: 16 },
        { label: "Dept. of Homeland Security", lat: 38.8481, lon: -77.0007, zoom: 15 },
      ],
    },
  ];

  const getZoomLevel = () => {
    if (props.viewport?.zoom > 12.5) return props.viewport.zoom;
    return 12.5;
  };

  const goToLatLon = (lat, lon, zoom) => {
    const z = typeof zoom === 'number' ? zoom : getZoomLevel();
    props.setViewport({ latitude: lat, longitude: lon, zoom: z });
    props.setCenterLatitude(lat);
    props.setCenterLongitude(lon);
  };

  function normalizeMgrs(s) {
    // Collapse whitespace, uppercase, trim.
    return s.trim().replace(/\s+/g, ' ').toUpperCase();
  }

  function isLikelyMgrs(s) {
    // MGRS general shape:
    //   GZD (1-2 digits + zone letter) + 2 grid letters + even number of digits (0..10) for easting/northing
    // Examples:
    //   10SEG1234567890
    //   10S EG 12345 67890
    //   33UXP04
    const t = normalizeMgrs(s).replace(/ /g, '');

    // 1-2 digits, zone letter C-X (excluding I,O)
    // 2 grid letters A-Z (excluding I,O)
    // 0..10 digits, but if present must be even (2,4,6,8,10)
    if (!/^\d{1,2}[C-HJ-NP-X][A-HJ-NP-Z]{2}\d{0,10}$/.test(t)) return false;

    const digits = t.match(/\d+$/)?.[0] ?? '';
    if (digits.length > 0 && digits.length % 2 !== 0) return false;

    return true;
  }

  function parseCoordinates(input) {
    if (!input || typeof input !== 'string') {
      throw new Error('Empty input');
    }

    const str = input.trim();

    // -----------------------------
    // 0) MGRS
    // -----------------------------
    if (isLikelyMgrs(str)) {
      try {
        // mgrs.toPoint returns [lon, lat]
        const [lon, lat] = mgrs.toPoint(normalizeMgrs(str));
        if (isValidLatLon(lat, lon)) {
          return { lat, lon, format: 'mgrs' };
        }
        throw new Error('MGRS converted to invalid lat/lon');
      } catch (e) {
        throw new Error('Invalid MGRS coordinate');
      }
    }

    // -----------------------------
    // 1) Decimal degrees (lat, lon)
    // -----------------------------
    let m = str.match(/(-?\d+(?:\.\d+)?)\s*[,\s]\s*(-?\d+(?:\.\d+)?)/i);
    if (m) {
      const lat = Number(m[1]);
      const lon = Number(m[2]);
      if (isValidLatLon(lat, lon)) return { lat, lon, format: 'decimal' };
    }

    // -----------------------------------
    // 2) DMS
    // -----------------------------------
    m = str.match(
      /(\d{1,3})[°\s]+(\d{1,2})['\s]+(\d{1,2}(?:\.\d+)?)[\"\s]*([NS])[\s,]+(\d{1,3})[°\s]+(\d{1,2})['\s]+(\d{1,2}(?:\.\d+)?)[\"\s]*([EW])/i
    );
    if (m) {
      const lat = dmsToDecimal(m[1], m[2], m[3], m[4]);
      const lon = dmsToDecimal(m[5], m[6], m[7], m[8]);
      if (isValidLatLon(lat, lon)) return { lat, lon, format: 'dms' };
    }

    // -----------------------------------
    // 3) DM
    // -----------------------------------
    m = str.match(/(\d{1,3})\s+(\d+(?:\.\d+)?)\s*([NS])[\s,]+(\d{1,3})\s+(\d+(?:\.\d+)?)\s*([EW])/i);
    if (m) {
      const lat = dmToDecimal(m[1], m[2], m[3]);
      const lon = dmToDecimal(m[4], m[5], m[6]);
      if (isValidLatLon(lat, lon)) return { lat, lon, format: 'dm' };
    }

    throw new Error('Unrecognized coordinate format');
  }

  function isValidLatLon(lat, lon) {
    return (
      Number.isFinite(lat) &&
      Number.isFinite(lon) &&
      lat >= -90 &&
      lat <= 90 &&
      lon >= -180 &&
      lon <= 180
    );
  }

  function dmsToDecimal(deg, min, sec, hemi) {
    let val = Number(deg) + Number(min) / 60 + Number(sec) / 3600;
    if (hemi === 'S' || hemi === 'W') val *= -1;
    return val;
  }

  function dmToDecimal(deg, min, hemi) {
    let val = Number(deg) + Number(min) / 60;
    if (hemi === 'S' || hemi === 'W') val *= -1;
    return val;
  }

  function handleCoordinateJump(value, close) {
    try {
      const { lat, lon } = parseCoordinates(value);
      goToLatLon(lat, lon, 14);
      close?.();
    } catch (err) {
      alert(err.message);
    }
  }

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    } else {
      props.setCurrentLatitude(null);
      props.setCurrentLongitude(null);
      alert('There was an error geolocating you.');
    }
  }

  function showPosition(position) {
    const z = getZoomLevel();
    props.setViewport({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      zoom: z,
    });
    props.setCenterLatitude(position.coords.latitude);
    props.setCenterLongitude(position.coords.longitude);
    props.setCurrentLatitude(position.coords.latitude);
    props.setCurrentLongitude(position.coords.longitude);
  }

  function showError(error) {
    props.setCurrentLatitude(null);
    props.setCurrentLongitude(null);
    switch (error.code) {
      case error.PERMISSION_DENIED:
        props.setGpsSnackbarOpen?.(true);
        console.log('User denied the request for Geolocation.');
        break;
      case error.POSITION_UNAVAILABLE:
        console.log('Location information is unavailable.');
        break;
      case error.TIMEOUT:
        console.log('The request to get user location timed out.');
        break;
      case error.UNKNOWN_ERROR:
        console.log('An unknown error occurred.');
        break;
      default:
        console.log('Geolocation error.');
    }
  }

  const getMapboxToken = () =>
    props.mapboxToken ||
    process.env.REACT_APP_MAPBOX_TOKEN ||
    process.env.NEXT_PUBLIC_MAPBOX_TOKEN ||
    '';

  const timeMin = props.timeBounds?.min ?? null;
  const timeMax = props.timeBounds?.max ?? null;
  const rangeMin = props.timeRangeMs?.min ?? timeMin;
  const rangeMax = props.timeRangeMs?.max ?? timeMax;
  const stepMs = 60 * 1000;
  const QR_SIZE = 184;
  const fallbackShareUrl = typeof window !== 'undefined' ? window.location.href : '';
  const shareValue = String(props.shareUrl || fallbackShareUrl || '').trim();
  const downloadQrSvg = () => {
    const svg = qrContainerRef.current?.querySelector('svg');
    if (!svg) return;

    const serializer = new XMLSerializer();
    let source = serializer.serializeToString(svg);

    if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
      source = source.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
    }
    if (!source.match(/^<svg[^>]+"http:\/\/www\.w3\.org\/1999\/xlink"/)) {
      source = source.replace('<svg', '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
    }

    const blob = new Blob([source], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'project-civilian-qr.svg';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  };

  const downloadQrPng = () => {
    const svg = qrContainerRef.current?.querySelector('svg');
    if (!svg) return;

    const serializer = new XMLSerializer();
    let source = serializer.serializeToString(svg);
    if (!source.match(/^<svg[^>]+xmlns="http:\/\/www\.w3\.org\/2000\/svg"/)) {
      source = source.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg"');
    }

    const svgBlob = new Blob([source], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);
    const img = new Image();
    const scale = 3;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = QR_SIZE * scale;
      canvas.height = QR_SIZE * scale;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        URL.revokeObjectURL(url);
        return;
      }
      ctx.imageSmoothingEnabled = false;
      ctx.setTransform(scale, 0, 0, scale, 0, 0);
      ctx.drawImage(img, 0, 0, QR_SIZE, QR_SIZE);
      canvas.toBlob((blob) => {
        if (!blob) {
          URL.revokeObjectURL(url);
          return;
        }
        const pngUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = pngUrl;
        link.download = 'project-civilian-qr.png';
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(pngUrl);
      }, 'image/png');
      URL.revokeObjectURL(url);
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
    };

    img.src = url;
  };

  const formatTime = (ms) => {
    if (!Number.isFinite(ms)) return 'N/A';
    return new Date(ms).toLocaleString();
  };

  const rangePct = (() => {
    if (!Number.isFinite(timeMin) || !Number.isFinite(timeMax) || timeMax <= timeMin) {
      return { min: 0, max: 100 };
    }
    const minPct = ((rangeMin - timeMin) / (timeMax - timeMin)) * 100;
    const maxPct = ((rangeMax - timeMin) / (timeMax - timeMin)) * 100;
    return {
      min: Math.max(0, Math.min(100, minPct)),
      max: Math.max(0, Math.min(100, maxPct)),
    };
  })();

  const toLocalInputValue = (ms) => {
    if (!Number.isFinite(ms)) return "";
    const d = new Date(ms);
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const resetAllFilters = () => {
    props.filterData?.('');
    props.setSearch?.('');
    props.setSearchMade?.(false);
    props.setSearchText?.('Search');

    if (Number.isFinite(timeMin) && Number.isFinite(timeMax)) {
      props.setTimeRangeMs?.({ min: timeMin, max: timeMax });
    }

    props.setFocusBox?.(null);
    props.setGeoJSONFilterGeometry?.(null);
    props.setIsDrawingBox?.(false);
    countryApplyRequestRef.current += 1;
    setShowGeoJSONAdvanced(false);
    setGeoJSONFilterText('');
    setGeoJSONFilterError('');
    setCountryGeoJSONApplying(false);
    setSelectedCountryGeoJSONId('');
    setCountryGeoJSONSubregionOptions([]);
    setSelectedCountryGeoJSONSubregionId('');
    setCountryGeoJSONSearchText('');
    setCountryGeoJSONError('');
    props.setGeoJSONCountryFilterId?.('');
    props.setGeoJSONCountrySubregionId?.('');
    setFilterResetVersion((v) => v + 1);
  };

  const applyQuickRange = (hours) => {
    if (!Number.isFinite(timeMax)) return;
    const end = timeMax;
    const start = hours === 0 ? end : end - hours * 60 * 60 * 1000;
    const clampedStart = Number.isFinite(timeMin) ? Math.max(timeMin, start) : start;
    props.setTimeRangeMs({ min: clampedStart, max: end });
  };

  const getDisplayText = (value) => {
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'number' || typeof value === 'boolean') return String(value);
    return '';
  };

  useEffect(() => {
    let mounted = true;

    const loadCountryGeoJSONIndex = async () => {
      setCountryGeoJSONLoading(true);
      setCountryGeoJSONError('');

      try {
        const response = await fetch('/countries.dropdown.json');
        if (!response.ok) {
          throw new Error(`Failed to load countries.dropdown.json (${response.status})`);
        }

        const data = await response.json();
        const entries = Array.isArray(data?.entries) ? data.entries : [];

        const options = entries
          .map((entry, index) => {
            const id = getDisplayText(entry?.id) || `country-${index + 1}`;
            const countryName = getDisplayText(entry?.name) || 'Unknown';
            const isoCode = getDisplayText(entry?.iso) || '';
            if (!id) return null;

            return {
              id,
              countryName,
              isoCode,
              label: countryName,
            };
          })
          .filter(Boolean)
          .sort((a, b) => a.countryName.localeCompare(b.countryName));

        if (!mounted) return;
        setCountryGeoJSONOptions(options);
      } catch (error) {
        if (!mounted) return;
        setCountryGeoJSONOptions([]);
        setCountryGeoJSONError('Unable to load countries dropdown data.');
      } finally {
        if (!mounted) return;
        setCountryGeoJSONLoading(false);
      }
    };

    loadCountryGeoJSONIndex();

    return () => {
      mounted = false;
    };
  }, []);

  const filteredCountryGeoJSONOptions = useMemo(() => {
    const searchText = String(countryGeoJSONSearchText || '').trim().toLowerCase();
    if (!searchText) return countryGeoJSONOptions;

    return countryGeoJSONOptions.filter((option) => {
      const label = String(option?.label || '').toLowerCase();
      const id = String(option?.id || '').toLowerCase();
      const countryName = String(option?.countryName || '').toLowerCase();
      const isoCode = String(option?.isoCode || '').toLowerCase();
      return (
        label.includes(searchText) ||
        id.includes(searchText) ||
        countryName.includes(searchText) ||
        isoCode.includes(searchText)
      );
    });
  }, [countryGeoJSONOptions, countryGeoJSONSearchText]);

  const normalizeCountrySearchValue = (value) => String(value || '').trim().toLowerCase();

  const findCountryOptionByText = (value) => {
    const normalized = normalizeCountrySearchValue(value);
    if (!normalized) return null;

    return (
      countryGeoJSONOptions.find((option) => {
        const countryName = normalizeCountrySearchValue(option?.countryName || option?.label);
        const isoCode = normalizeCountrySearchValue(option?.isoCode);
        const id = normalizeCountrySearchValue(option?.id);
        return countryName === normalized || isoCode === normalized || id === normalized;
      }) || null
    );
  };

  const handleCountryGeoJSONSearchChange = (event) => {
    const nextValue = event.target.value;
    setCountryGeoJSONSearchText(nextValue);

    const normalized = normalizeCountrySearchValue(nextValue);
    if (!normalized) {
      if (selectedCountryGeoJSONId) {
        applyCountryGeoJSONFilter('');
      }
      return;
    }

    const matched = findCountryOptionByText(nextValue);
    if (!matched || matched.id === selectedCountryGeoJSONId) return;
    applyCountryGeoJSONFilter(matched.id, { closeFilter: true });
  };

  const trimmedCountryGeoJSONSearchText = String(countryGeoJSONSearchText || '').trim();
  const canClearCountrySearch = Boolean(
    trimmedCountryGeoJSONSearchText || selectedCountryGeoJSONId || props.geoJSONCountryFilterId
  );
  const showCountrySuggestions =
    isCountrySearchFocused &&
    Boolean(trimmedCountryGeoJSONSearchText) &&
    !countryGeoJSONLoading &&
    !countryGeoJSONApplying &&
    filteredCountryGeoJSONOptions.length > 0;
  const MAX_COUNTRY_SUGGESTIONS = 8;
  const countrySuggestionOptions = showCountrySuggestions
    ? filteredCountryGeoJSONOptions.slice(0, MAX_COUNTRY_SUGGESTIONS)
    : [];

  const handleCountrySuggestionPick = (option) => {
    if (!option?.id) return;
    setCountryGeoJSONSearchText(option.countryName || option.label || '');
    setIsCountrySearchFocused(false);
    applyCountryGeoJSONFilter(option.id, { closeFilter: true });
  };

  const activeCountryId = String(selectedCountryGeoJSONId || props.geoJSONCountryFilterId || '').trim();
  const activeCountryOption = useMemo(() => {
    if (!activeCountryId) return null;
    return countryGeoJSONOptions.find((option) => option.id === activeCountryId) || null;
  }, [activeCountryId, countryGeoJSONOptions]);
  const activeSubregionId = String(
    selectedCountryGeoJSONSubregionId || props.geoJSONCountrySubregionId || ''
  ).trim();
  const activeSubregionLabel = useMemo(() => {
    if (!activeSubregionId) return '';
    const match = countryGeoJSONSubregionOptions.find((option) => option.id === activeSubregionId);
    return match?.label || activeSubregionId;
  }, [activeSubregionId, countryGeoJSONSubregionOptions]);

  const focusBoxDisplay = useMemo(() => {
    if (!Array.isArray(props.focusBox) || props.focusBox.length !== 4) return '';
    const values = props.focusBox.map((entry) => Number(entry));
    if (!values.every(Number.isFinite)) return '';
    return values.map((entry) => entry.toFixed(5)).join(', ');
  }, [props.focusBox]);

  const searchFilterValue = String(props.search || '').trim();
  const searchFilterActive = Boolean(searchFilterValue);

  const timeFilterActive = useMemo(() => {
    const min = Number(props.timeRangeMs?.min);
    const max = Number(props.timeRangeMs?.max);
    if (!Number.isFinite(min) || !Number.isFinite(max)) return false;
    const boundsMin = Number(props.timeBounds?.min);
    const boundsMax = Number(props.timeBounds?.max);
    if (!Number.isFinite(boundsMin) || !Number.isFinite(boundsMax)) return true;
    return Math.abs(min - boundsMin) > 1000 || Math.abs(max - boundsMax) > 1000;
  }, [props.timeRangeMs, props.timeBounds]);

  const timeFilterLabel = useMemo(() => {
    if (!timeFilterActive) return '';
    const min = new Date(props.timeRangeMs?.min);
    const max = new Date(props.timeRangeMs?.max);
    if (Number.isNaN(min.getTime()) || Number.isNaN(max.getTime())) return '';
    return `${min.toLocaleString()} – ${max.toLocaleString()}`;
  }, [props.timeRangeMs, timeFilterActive]);

  const geoJSONCustomActive = Boolean(props.geoJSONFilterGeometry) && !activeCountryId;
  const geoJSONCustomLabel = useMemo(() => {
    if (!geoJSONCustomActive) return '';
    const type = props.geoJSONFilterGeometry?.type;
    if (type === 'FeatureCollection') {
      const count = Array.isArray(props.geoJSONFilterGeometry.features)
        ? props.geoJSONFilterGeometry.features.length
        : 0;
      return `Custom GeoJSON: ${count} feature${count === 1 ? '' : 's'}`;
    }
    if (type === 'Feature') return 'Custom GeoJSON: 1 feature';
    return `Custom GeoJSON: ${type || 'active'}`;
  }, [geoJSONCustomActive, props.geoJSONFilterGeometry]);

  useEffect(() => {
    if (!filterOpen) {
      setActiveFilterSection('');
    }
  }, [filterOpen]);

  const getFilterSectionClass = (sectionKey) => {
    if (!activeFilterSection || activeFilterSection === sectionKey) {
      return 'opacity-100';
    }
    return 'opacity-35';
  };

  const loadCountrySubregions = async (countryId) => {
    const normalizedCountryId = String(countryId || '').trim();
    if (!normalizedCountryId) {
      return {
        defaultSubregionId: '',
        options: [],
      };
    }

    if (countrySubregionCacheRef.current.has(normalizedCountryId)) {
      return countrySubregionCacheRef.current.get(normalizedCountryId);
    }

    const params = new URLSearchParams({
      countryId: normalizedCountryId,
    });
    const response = await fetch(`/api/countries/subregions?${params.toString()}`);
    if (!response.ok) {
      throw new Error(`Failed to load country subregions (${response.status})`);
    }

    const data = await response.json();
    const options = Array.isArray(data?.options)
      ? data.options
          .map((option) => {
            const id = String(option?.id || '').trim();
            const label = String(option?.label || '').trim();
            if (!id || !label) return null;
            return { id, label };
          })
          .filter(Boolean)
      : [];
    const defaultSubregionId = String(data?.defaultSubregionId || '').trim();
    const payload = {
      defaultSubregionId,
      options,
    };

    countrySubregionCacheRef.current.set(normalizedCountryId, payload);
    return payload;
  };

  const isValidLngLat = (lon, lat) =>
    Number.isFinite(lon) &&
    Number.isFinite(lat) &&
    lon >= -180 &&
    lon <= 180 &&
    lat >= -90 &&
    lat <= 90;

  const validateCoordinateTree = (coordinates) => {
    if (!Array.isArray(coordinates)) {
      throw new Error('GeoJSON geometry has invalid coordinates.');
    }

    if (
      coordinates.length >= 2 &&
      typeof coordinates[0] === 'number' &&
      typeof coordinates[1] === 'number'
    ) {
      const lon = Number(coordinates[0]);
      const lat = Number(coordinates[1]);
      if (!isValidLngLat(lon, lat)) {
        throw new Error('GeoJSON has invalid longitude/latitude values.');
      }
      return;
    }

    coordinates.forEach((entry) => validateCoordinateTree(entry));
  };

  const geometryHasPolygon = (geometry) => {
    if (!geometry || typeof geometry !== 'object') return false;

    if (geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
      validateCoordinateTree(geometry.coordinates);
      return true;
    }

    if (geometry.type === 'GeometryCollection') {
      const geometries = Array.isArray(geometry.geometries) ? geometry.geometries : [];
      if (!geometries.length) {
        throw new Error('GeoJSON GeometryCollection has no geometries.');
      }
      return geometries.some((entry) => geometryHasPolygon(entry));
    }

    if (Array.isArray(geometry.coordinates)) {
      validateCoordinateTree(geometry.coordinates);
    }

    return false;
  };

  const geoJSONHasPolygon = (input) => {
    if (!input || typeof input !== 'object') return false;

    if (input.type === 'Feature') {
      return geometryHasPolygon(input.geometry);
    }

    if (input.type === 'FeatureCollection') {
      const features = Array.isArray(input.features) ? input.features : [];
      if (!features.length) {
        throw new Error('GeoJSON FeatureCollection has no features.');
      }
      return features.some((feature) => geometryHasPolygon(feature?.geometry));
    }

    return geometryHasPolygon(input);
  };

  const parseGeoJSONPolygonFilter = (text) => {
    const trimmed = String(text || '').trim();
    if (!trimmed) {
      throw new Error('Paste a GeoJSON feature first.');
    }

    let parsed;
    try {
      parsed = JSON.parse(trimmed);
    } catch (error) {
      throw new Error('GeoJSON is not valid JSON.');
    }

    if (typeof parsed?.type !== 'string') {
      throw new Error('Paste a GeoJSON Feature, FeatureCollection, or Geometry object.');
    }

    const hasPolygon = geoJSONHasPolygon(parsed);
    if (!hasPolygon) {
      throw new Error('GeoJSON must include at least one Polygon or MultiPolygon.');
    }

    return parsed;
  };

  const applyGeoJSONFilter = () => {
    try {
      const geoJSONFilter = parseGeoJSONPolygonFilter(geoJSONFilterText);
      props.setGeoJSONFilterGeometry?.(geoJSONFilter);
      // Keep geojson filtering separate from rectangular focus-box filtering.
      props.setFocusBox?.(null);
      props.setIsDrawingBox?.(false);
      countryApplyRequestRef.current += 1;
      setCountryGeoJSONApplying(false);
      setGeoJSONFilterError('');
      setSelectedCountryGeoJSONId('');
      setCountryGeoJSONSubregionOptions([]);
      setSelectedCountryGeoJSONSubregionId('');
      setCountryGeoJSONSearchText('');
      setCountryGeoJSONError('');
      props.setGeoJSONCountryFilterId?.('');
      props.setGeoJSONCountrySubregionId?.('');
      setFilterOpen(false);
    } catch (error) {
      setGeoJSONFilterError(error.message || 'Unable to apply GeoJSON filter.');
    }
  };

  const applyCountryGeoJSONFilter = async (countryId, config = {}) => {
    const normalizedCountryId = String(countryId || '').trim();
    const shouldCloseFilter = config?.closeFilter !== false;
    const requestId = countryApplyRequestRef.current + 1;
    countryApplyRequestRef.current = requestId;

    setSelectedCountryGeoJSONId(normalizedCountryId);
    setCountryGeoJSONError('');
    setGeoJSONFilterError('');

    if (!normalizedCountryId) {
      props.setGeoJSONFilterGeometry?.(null);
      props.setGeoJSONCountryFilterId?.('');
      props.setGeoJSONCountrySubregionId?.('');
      setCountryGeoJSONSubregionOptions([]);
      setSelectedCountryGeoJSONSubregionId('');
      setCountryGeoJSONSearchText('');
      setCountryGeoJSONApplying(false);
      return;
    }

    const selectedCountry = countryGeoJSONOptions.find((entry) => entry.id === normalizedCountryId);
    if (!selectedCountry) {
      setCountryGeoJSONError('Selected country geometry was not found.');
      setCountryGeoJSONApplying(false);
      return;
    }

    setCountryGeoJSONApplying(true);
    setCountryGeoJSONSearchText(selectedCountry.countryName || selectedCountry.label || '');
    lastAutoAppliedCountryIdRef.current = normalizedCountryId;

    try {
      const subregionPayload = await loadCountrySubregions(normalizedCountryId);
      if (requestId !== countryApplyRequestRef.current) return;

      const subregionOptions = Array.isArray(subregionPayload?.options) ? subregionPayload.options : [];
      const hasConfigSubregion = Object.prototype.hasOwnProperty.call(config, 'subregionId');
      let normalizedSubregionId = hasConfigSubregion
        ? String(config?.subregionId || '').trim()
        : String(selectedCountryGeoJSONSubregionId || '').trim();

      if (subregionOptions.length) {
        const hasSubregion = subregionOptions.some((option) => option.id === normalizedSubregionId);
        if (!hasSubregion) {
          normalizedSubregionId =
            String(subregionPayload?.defaultSubregionId || '').trim() || subregionOptions[0].id;
        }
      } else {
        normalizedSubregionId = '';
      }

      setCountryGeoJSONSubregionOptions(subregionOptions);
      setSelectedCountryGeoJSONSubregionId(normalizedSubregionId);

      const cacheKey = `${normalizedCountryId}::${normalizedSubregionId || '__all__'}`;
      let featureCollection = countryFeatureCollectionCacheRef.current.get(cacheKey);

      if (!featureCollection) {
        const params = new URLSearchParams({
          countryId: normalizedCountryId,
        });
        if (normalizedSubregionId) {
          params.set('subregionId', normalizedSubregionId);
        }

        const response = await fetch(`/api/countries/geometry?${params.toString()}`);
        if (!response.ok) {
          throw new Error(`Failed to load country geometry (${response.status})`);
        }

        const data = await response.json();
        const sourceFeatures = Array.isArray(data?.features) ? data.features : [];
        if (requestId !== countryApplyRequestRef.current) return;

        const selectedFeatures = sourceFeatures
          .filter((feature) => feature?.geometry && typeof feature.geometry === 'object');

        if (!selectedFeatures.length) {
          throw new Error('No valid geometry features found for selected country.');
        }

        featureCollection = {
          type: 'FeatureCollection',
          features: selectedFeatures
        };

        countryFeatureCollectionCacheRef.current.set(cacheKey, featureCollection);
      }

      if (requestId !== countryApplyRequestRef.current) return;

      props.setGeoJSONFilterGeometry?.(featureCollection);
      props.setGeoJSONCountryFilterId?.(normalizedCountryId);
      props.setGeoJSONCountrySubregionId?.(normalizedSubregionId);
      props.setFocusBox?.(null);
      props.setIsDrawingBox?.(false);
      const hasSubregions = subregionOptions.length > 0;
      const hasChosenSubregion = Boolean(normalizedSubregionId);
      if (shouldCloseFilter && (!hasSubregions || hasChosenSubregion)) {
        setFilterOpen(false);
      }
    } catch (error) {
      if (requestId !== countryApplyRequestRef.current) return;
      setCountryGeoJSONError('Unable to load selected country geometry.');
    } finally {
      if (requestId === countryApplyRequestRef.current) {
        setCountryGeoJSONApplying(false);
      }
    }
  };

  useEffect(() => {
    if (countryGeoJSONLoading || !countryGeoJSONOptions.length) return;

    const requestedCountryId = String(props.geoJSONCountryFilterId || '').trim();
    const requestedSubregionId = String(props.geoJSONCountrySubregionId || '').trim();
    if (!requestedCountryId) {
      lastAutoAppliedCountryIdRef.current = '';
      if (selectedCountryGeoJSONId) {
        setSelectedCountryGeoJSONId('');
      }
      setCountryGeoJSONSubregionOptions([]);
      setSelectedCountryGeoJSONSubregionId('');
      return;
    }

    const matched = countryGeoJSONOptions.find((entry) => entry.id === requestedCountryId);
    if (!matched) return;

    setCountryGeoJSONSearchText(matched.countryName || matched.label || '');
    const isSubregionSynced =
      !requestedSubregionId || selectedCountryGeoJSONSubregionId === requestedSubregionId;

    if (
      lastAutoAppliedCountryIdRef.current === requestedCountryId &&
      selectedCountryGeoJSONId === requestedCountryId &&
      isSubregionSynced
    ) {
      return;
    }

    lastAutoAppliedCountryIdRef.current = requestedCountryId;
    applyCountryGeoJSONFilter(requestedCountryId, {
      closeFilter: false,
      subregionId: requestedSubregionId,
    });
  }, [
    countryGeoJSONLoading,
    countryGeoJSONOptions,
    props.geoJSONCountryFilterId,
    props.geoJSONCountrySubregionId,
  ]);

  const handleNearestClick = () => {
    const jumped = props.goToNearestPost?.();
    if (jumped === false) {
      alert('No nearby posts found to jump to.');
      return;
    }
    setGpsOpen(false);
  };

  const geocodeAddress = async (q) => {
    const token = getMapboxToken();
    if (!token) {
      alert('Missing Mapbox token. Pass props.mapboxToken or set REACT_APP_MAPBOX_TOKEN / NEXT_PUBLIC_MAPBOX_TOKEN.');
      return null;
    }
    if (!q || !q.trim()) return null;

    setGeoLoading(true);
    try {
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
        q.trim()
      )}.json?access_token=${encodeURIComponent(token)}&limit=1`;
      const res = await fetch(url);
      const json = await res.json();
      const feature = json?.features?.[0];
      const center = feature?.center; // [lon, lat]
      if (!center || center.length !== 2) return null;
      return { lon: center[0], lat: center[1] };
    } catch (e) {
      console.log('Geocode error:', e);
      return null;
    } finally {
      setGeoLoading(false);
    }
  };

  const GpsPopup = (p) => {
    return (
      <>

      </>
    );
  };

  return (
    <header className="header bg-transparent ">
      <nav className="header mx-auto flex max-w-7xl items-center justify-between p-1 lg:px-8" aria-label="Global">
        <div className="projectCivilian-header flex lg:flex-1">
          <a className="">
            <img className=" mr-3 w-10 projectCivilian-logo" src="logo.svg" alt="" />
          </a>
          <div className="text-sm mt-3.5">projectCivilian</div>
        </div>
        {/* Mobile right-side controls */}
        <div className="lg:hidden flex items-center gap-2">
            {/* <GpsPopup
             
            /> */}
          {Auth.loggedIn() && (
            <button
              type="button"
              className="btn-active"
              style={{ verticalAlign: 'center' }}
              onClick={() => {
                setMobileMenuOpen(false);
                props.setIsPostPaneOpen(true);
              }}
            >
              Report
            </button>
          )}

          {!Auth.loggedIn() && (
            <>
              <button
                type="button"
                className="btn-active"
                style={{ verticalAlign: 'center'}}
                onClick={() => {
                  setMobileMenuOpen(false);
                  props.setIsRegisterPaneOpen(true);
                }}
              >
                Register
              </button>
              <button
                type="button"
                className="btn-active"
                style={{ verticalAlign: 'center' }}
                onClick={() => {
                  setMobileMenuOpen(false);
                  props.setIsLoginPaneOpen(true);
                }}
              >
                Log In
              </button>
            </>
          )}

          {/* GPS dropdown button (mobile) */}


          <button
            type="button"
            className="inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open Main Menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>

        {/* Desktop nav */}
        <div className="hidden lg:flex lg:gap-x-6 items-center">
          {/* GPS dropdown button (desktop) */}
        <GpsPopup
          currentLatitude={props.currentLatitude}
          currentLongitude={props.currentLongitude}
          setCenterLatitude={props.setCenterLatitude}
          setCenterLongitude={props.setCenterLongitude}
        />

          <HeaderOptions
            getLocation={getLocation}
            setIsVisiblePaneOpen={props.setIsVisiblePaneOpen}
            setIsRegisterPaneOpen={props.setIsRegisterPaneOpen}
            setIsLoginPaneOpen={props.setIsLoginPaneOpen}
            setIsProfilePaneOpen={props.setIsProfilePaneOpen}
            setIsPostPaneOpen={props.setIsPostPaneOpen}
          />
        </div>
      </nav>
      <div className="mx-auto w-full max-w-7xl px-4 pb-2 lg:px-8">
        <div className="flex flex-col gap-1">
          <div className="text-xs text-gray-300">
            {props.pointsLoading ? (
              <>
                Loading posts
                <span className="loading-ellipsis" aria-hidden="true">
                  <span className="loading-ellipsis__dot"></span>
                  <span className="loading-ellipsis__dot"></span>
                  <span className="loading-ellipsis__dot"></span>
                </span>
                <br/>
              </>
            ) : timeMin == null || timeMax == null ? (
              <>No points found.<br/></>
            ) : (
              <>
                Time range: {formatTime(rangeMin)} - {formatTime(rangeMax)}.<br/>Showing {props.postLength} points.
              </>
            )}
          </div>
          <>
          <div className="mx-auto grid w-fit grid-cols-3 place-items-stretch gap-2">
            <button
              type="button"
              className="btn-active"
              style={{ verticalAlign: "middle" }}
              onClick={() => {
                setGpsOpen((v) => !v);
                setFilterOpen(false);
                setShareOpen(false);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-3 w-3 mr-1">
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM6.262 6.072a8.25 8.25 0 1 0 10.562-.766 4.5 4.5 0 0 1-1.318 1.357L14.25 7.5l.165.33a.809.809 0 0 1-1.086 1.085l-.604-.302a1.125 1.125 0 0 0-1.298.21l-.132.131c-.439.44-.439 1.152 0 1.591l.296.296c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 0 1-2.288 4.04l-.723.724a1.125 1.125 0 0 1-1.298.21l-.153-.076a1.125 1.125 0 0 1-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 0 1-.21-1.298L9.75 12l-1.64-1.64a6 6 0 0 1-1.676-3.257l-.172-1.03Z" clip-rule="evenodd" />
              </svg>
              Navigation
              <ChevronDownIcon className="h-3 w-3 ml-1 text-gray-400" aria-hidden="true" />
            </button>
            <button
              type="button"
              className="btn-active"
              onClick={() => {
                setFilterOpen((v) => !v);
                setGpsOpen(false);
                setShareOpen(false);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-3 w-3 mr-1">
                <path d="M18.75 12.75h1.5a.75.75 0 0 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM12 6a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 6ZM12 18a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 12 18ZM3.75 6.75h1.5a.75.75 0 1 0 0-1.5h-1.5a.75.75 0 0 0 0 1.5ZM5.25 18.75h-1.5a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5ZM3 12a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 3 12ZM9 3.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM9 15.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z" />
              </svg>
              Filter
              <ChevronDownIcon className="h-3 w-3 ml-1  text-gray-400" aria-hidden="true" />
            </button>
            <button
              type="button"
              className="btn-active"
              onClick={() => {
                setShareOpen((v) => !v);
                setGpsOpen(false);
                setFilterOpen(false);
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-3 w-3 mr-1">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
              </svg>

              Share
              <ChevronDownIcon className="h-3 w-3 ml-1 text-gray-400" aria-hidden="true" />
            </button>
          </div>
          <div className="">
            <button
              type="button"
              className="rounded-lg bg-red-600 px-2 py-1 text-[8px] font-semibold text-white hover:bg-red-500"
              onClick={resetAllFilters}
            >
              Reset All Filters
            </button>
          </div>
          <Transition
              show={gpsOpen}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <div
                className="fixed inset-0 z-50 flex items-center justify-center p-4"
                onPointerDown={(e) => {
                  if (e.target === e.currentTarget) setGpsOpen(false);
                }}
              >
                <div
                  className="w-96 max-w-[95vw] overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/10"
                  onClick={(e) => e.stopPropagation()}
                  onPointerDownCapture={(e) => e.stopPropagation()}
                  onTouchStartCapture={(e) => e.stopPropagation()}
                >
                  <div className="p-3">
                    <div className="flex items-center justify-between mb-2">
                      <div className="text-xs font-semibold text-gray-600">Navigate</div>
                      <button
                        type="button"
                        onClick={() => setGpsOpen(false)}
                        className="rounded-md p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                        aria-label="Close"
                      >
                        <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                      </button>
                    </div>

                    <div className="rounded-lg bg-gray-50 p-3">
                      <button
                        type="button"
                        onClick={() => {
                          getLocation();
                          setGpsOpen(false);
                        }}
                        className="rounded-lg w-full bg-gray-900 px-3 py-2 text-sm font-semibold text-white hover:bg-gray-800 disabled:opacity-60"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-3 w-3 mr-1 inline">
                          <path fill-rule="evenodd" d="m11.54 22.351.07.04.028.016a.76.76 0 0 0 .723 0l.028-.015.071-.041a16.975 16.975 0 0 0 1.144-.742 19.58 19.58 0 0 0 2.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 0 0-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 0 0 2.682 2.282 16.975 16.975 0 0 0 1.145.742ZM12 13.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd" />
                        </svg>

                        Go to my location
                        {props.currentLatitude && props.currentLongitude && (
                          <div className="text-xs font-normal text-gray-500">
                            {props.currentLatitude.toFixed(6)}, {props.currentLongitude.toFixed(6)}
                          </div>
                        )}
                      </button>

                      <button
                        type="button"
                        onClick={handleNearestClick}
                        className="mt-2 rounded-lg w-full bg-gray-900 px-3 py-2 text-sm font-semibold text-white hover:bg-gray-800 disabled:opacity-60"
                        disabled={!props.postLength}
                      >
                        Nearest post
                      </button>

                      <div className="mt-2 text-xs font-semibold text-gray-600 mb-2">Search an Address</div>

                      <div className="mt-2">
                        <GpsAddressSearch
                          value={props.addressQuery}
                          onValueChange={(value) => props.setAddressQuery(value)}
                          onSearch={async () => {
                            const q = String(props.addressQuery || "").trim();
                            if (!q) return;

                            const hit = await geocodeAddress(q);
                            if (!hit) return alert("Address not found.");

                            goToLatLon(hit.lat, hit.lon, 14);
                            setGpsOpen(false);
                          }}
                          loading={geoLoading}
                        />
                      </div>
                    </div>

                    <div className="mt-3">
                      <div className="text-xs font-semibold text-gray-600 mb-2">Jump To</div>
                      <div className="rounded-lg bg-gray-50 p-3">
                        <select
                          defaultValue=""
                          className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!value) return;
                            const [latStr, lonStr, zoomStr] = value.split("|");
                            const lat = Number(latStr);
                            const lon = Number(lonStr);
                            const zoom = Number(zoomStr);
                            if (!Number.isFinite(lat) || !Number.isFinite(lon) || !Number.isFinite(zoom)) return;
                            goToLatLon(lat, lon, zoom);
                            setGpsOpen(false);
                            e.target.value = "";
                          }}
                        >
                          <option value="">Select a location</option>
                          {LANDMARK_GROUPS.map((group) => (
                            <React.Fragment key={group.label}>
                              <option value="" disabled>
                                {group.label}
                              </option>
                              {group.items.map((pt) => (
                                <option
                                  key={pt.label}
                                  value={`${pt.lat}|${pt.lon}|${pt.zoom}`}
                                >
                                  {pt.label}
                                </option>
                              ))}
                            </React.Fragment>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="mt-3 justify-between">
                      <div className="text-xs font-semibold text-gray-600 mb-2">State Capitol</div>

                      <div className="rounded-lg bg-gray-50 p-3">
                        <select
                          defaultValue=""
                          className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (!value) return;

                            const [latStr, lonStr] = value.split("|");
                            const lat = Number(latStr);
                            const lon = Number(lonStr);
                            if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;

                            goToLatLon(lat, lon, 12.5);
                            setGpsOpen(false);
                            e.target.value = "";
                          }}
                        >
                          <option value="">Select a state</option>
                          {STATE_CAPITALS.map((c) => (
                            <option key={c.state} value={`${c.lat}|${c.lon}`}>
                              {c.state} - {c.capital}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="mt-2 rounded-lg bg-gray-50 p-3">
                      <div className="text-xs font-semibold text-gray-600 mb-2">Go to Coordinates</div>

                      <GpsCoordinateSearch
                        value={props.latLonQuery}
                        onValueChange={(value) => props.setLatLonQuery(value)}
                        onSearch={() => {
                          handleCoordinateJump(String(props.latLonQuery || ""), () => setGpsOpen(false));
                        }}
                      />

                      <div className="mt-2 text-xs text-gray-500">
                        Examples:
                        <br />38.576668, -121.493629
                        <br />38??34'36"N 121??29'37"W
                        <br />10SEG1234567890
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Transition>
             <Transition
               show={filterOpen}
               as={Fragment}
               unmount={false}
               enter="transition ease-out duration-200"
               enterFrom="opacity-0 translate-y-1"
               enterTo="opacity-100 translate-y-0"
               leave="transition ease-in duration-150"
               leaveFrom="opacity-100 translate-y-0"
               leaveTo="opacity-0 translate-y-1"
             >
               <div
                 className="fixed inset-0 z-50 flex items-center justify-center p-4"
                 onPointerDown={(e) => {
                   if (e.target === e.currentTarget) setFilterOpen(false);
                 }}
               >
                 <div
                   className="w-96 max-w-[95vw] overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/10"
                   onClick={(e) => e.stopPropagation()}
                   onPointerDownCapture={(e) => e.stopPropagation()}
                   onTouchStartCapture={(e) => e.stopPropagation()}
                 >
                   <div className="p-3">
                   <div
                     className={`flex items-center justify-between mb-2 transition-opacity duration-150 ${
                       activeFilterSection ? 'opacity-35' : 'opacity-100'
                     }`}
                   >
                     <div className="flex items-center gap-2 text-xs font-semibold text-gray-600">
                       <span>Filter</span>
                       <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold text-gray-500">
                         {Number.isFinite(props.postLength) ? props.postLength : 0} posts displayed
                       </span>
                     </div>
                     <button
                       type="button"
                       onClick={() => setFilterOpen(false)}
                       className="rounded-md p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                       aria-label="Close"
                     >
                       <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                     </button>
                   </div>
                   <div className="space-y-3">
                  <div
                    className={`rounded-lg bg-gray-50 p-3 transition-opacity duration-150 ${getFilterSectionClass('time')}`}
                    onPointerDownCapture={() => setActiveFilterSection('time')}
                    onFocusCapture={() => setActiveFilterSection('time')}
                  >
                  <div className="text-xs font-semibold text-gray-600 mb-2">Time Range</div>
                  <div className="time-range-row justify-center mb-2">
                    {timeMin != null && timeMax != null && (
                      <div
                        className="time-range-slider"
                        style={{
                          '--range-start': `${rangePct.min}%`,
                          '--range-end': `${rangePct.max}%`,
                        }}
                      >
                        <input
                          type="range"
                          min={timeMin}
                          max={timeMax}
                          step={stepMs}
                          value={rangeMin}
                          onChange={(e) => {
                            const nextMin = Number(e.target.value);
                            props.setTimeRangeMs((prev) => ({
                              min: Math.min(nextMin, prev.max ?? timeMax),
                              max: prev.max ?? timeMax,
                            }));
                          }}
                          className="time-range-slider__input"
                          aria-label="Start time"
                        />
                        <input
                          type="range"
                          min={timeMin}
                          max={timeMax}
                          step={stepMs}
                          value={rangeMax}
                          onChange={(e) => {
                            const nextMax = Number(e.target.value);
                            props.setTimeRangeMs((prev) => ({
                              min: prev.min ?? timeMin,
                              max: Math.max(nextMax, prev.min ?? timeMin),
                            }));
                          }}
                          className="time-range-slider__input"
                          aria-label="End time"
                        />
                      </div>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                     <div className="flex flex-col gap-1">
                       <label className="text-[10px] text-gray-500">Start</label>
                       <input
                         type="datetime-local"
                         value={toLocalInputValue(rangeMin)}
                         min={toLocalInputValue(timeMin)}
                         max={toLocalInputValue(rangeMax)}
                         onChange={(e) => {
                           const next = new Date(e.target.value).getTime();
                           if (!Number.isFinite(next)) return;
                           props.setTimeRangeMs((prev) => ({
                             min: Math.min(next, prev.max ?? timeMax),
                             max: prev.max ?? timeMax,
                           }));
                         }}
                         className="w-full rounded-lg border border-gray-200 bg-white px-2 py-1 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                       />
                     </div>
                     <div className="flex flex-col gap-1">
                       <label className="text-[10px] text-gray-500">End</label>
                       <input
                         type="datetime-local"
                         value={toLocalInputValue(rangeMax)}
                         min={toLocalInputValue(rangeMin)}
                         max={toLocalInputValue(timeMax)}
                         onChange={(e) => {
                           const next = new Date(e.target.value).getTime();
                           if (!Number.isFinite(next)) return;
                           props.setTimeRangeMs((prev) => ({
                             min: prev.min ?? timeMin,
                             max: Math.max(next, prev.min ?? timeMin),
                           }));
                         }}
                         className="w-full rounded-lg border border-gray-200 bg-white px-2 py-1 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                       />
                     </div>
                  </div>
                  <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
                    <button
                      type="button"
                      className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800"
                      onClick={() => {
                        if (Number.isFinite(timeMin) && Number.isFinite(timeMax)) {
                          props.setTimeRangeMs({ min: timeMin, max: timeMax });
                        }
                      }}
                    >
                      Reset
                    </button>
                    <select
                      value={quickRangeHours}
                      onChange={(e) => {
                        const value = e.target.value;
                        setQuickRangeHours(value);
                        const hours = Number(value);
                        if (!Number.isFinite(hours)) return;
                        applyQuickRange(hours);
                      }}
                      className="rounded-lg border border-gray-200 bg-white px-2 py-2 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                      aria-label="Quick time range"
                    >
                      <option value="">Quick range...</option>
                      <option value="0">Now</option>
                      <option value="24">24 hours</option>
                      <option value="72">72 hours</option>
                      <option value="168">1 week</option>
                      <option value="336">2 weeks</option>
                      <option value="720">1 month</option>
                      <option value="4320">6 months</option>
                      <option value="8760">1 year</option>
                    </select>
                  </div>
                  </div>
                  <div
                    className={`rounded-lg bg-gray-50 p-3 transition-opacity duration-150 ${getFilterSectionClass('search')}`}
                    onPointerDownCapture={() => setActiveFilterSection('search')}
                    onFocusCapture={() => setActiveFilterSection('search')}
                  >
                  <div className="text-xs font-semibold text-gray-600 mb-2">Search</div>
                  <SearchArea
                    theme={props.theme}
                    searchMade={props.searchMade}
                    setSearchMade={props.setSearchMade}
                    setSearch={props.setSearch}
                    searchText={props.searchText}
                    setSearchText={props.setSearchText}
                    search={props.search}
                    postLength={props.postLength}
                    filterData={props.filterData}
                    filteredData={props.filteredData}
                    setFilteredData={props.setFilteredData}
                    resetVersion={filterResetVersion}
                  />
                  </div>
                  <div
                    className={`rounded-lg bg-gray-50 p-3 transition-opacity duration-150 ${getFilterSectionClass('focusBox')}`}
                    onPointerDownCapture={() => setActiveFilterSection('focusBox')}
                    onFocusCapture={() => setActiveFilterSection('focusBox')}
                  >
                  <div className="text-xs font-semibold text-gray-600 mb-2">Focus Box</div>
                  <div className="grid grid-cols-3 gap-2">
                    <button
                      type="button"
                      className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800"
                      onClick={() => {
                        props.setIsDrawingBox?.(true);
                        setFilterOpen(false);
                        // alert("Click and drag a box on the map to get more data on a region.")
                      }}
                    >
                      Focus Box
                    </button>
                    <button
                      type="button"
                      className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800"
                      onClick={() => {
                        if (Array.isArray(props.mapBounds) && props.mapBounds.length === 4) {
                          props.setFocusBox?.(props.mapBounds);
                        }
                      }}
                    >
                      Use Extent
                    </button>
                    <button
                      type="button"
                      className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800"
                      onClick={() => {
                        props.setFocusBox?.(null);
                      }}
                    >
                      Clear Box
                    </button>
                  </div>
                  {focusBoxDisplay && (
                    <div className="mt-2 text-[10px] text-gray-500">
                      Bounds: {focusBoxDisplay}
                    </div>
                  )}
                  </div>
                  <div
                    className={`rounded-lg bg-gray-50 p-3 transition-opacity duration-150 ${getFilterSectionClass('country')}`}
                    onPointerDownCapture={() => setActiveFilterSection('country')}
                    onFocusCapture={() => setActiveFilterSection('country')}
                  >
                  <div className="text-xs font-semibold text-gray-600 mb-2">Country Boundary</div>
                  <div className="mb-2 flex items-center gap-2">
                    <input
                      type="text"
                      value={countryGeoJSONSearchText}
                      onChange={handleCountryGeoJSONSearchChange}
                      onFocus={() => setIsCountrySearchFocused(true)}
                      onBlur={() => setIsCountrySearchFocused(false)}
                      placeholder="Type to search countries..."
                      className="w-full rounded-lg border border-gray-200 bg-white px-2 py-2 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                      disabled={countryGeoJSONLoading}
                      autoComplete="off"
                    />
                    <button
                      type="button"
                      className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800 disabled:opacity-60"
                      onClick={() => {
                        setIsCountrySearchFocused(false);
                        applyCountryGeoJSONFilter('');
                      }}
                      disabled={countryGeoJSONLoading || !canClearCountrySearch}
                    >
                      Clear
                    </button>
                  </div>
                  {countrySuggestionOptions.length > 0 && (
                    <div className="mb-2 max-h-40 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-sm">
                      {countrySuggestionOptions.map((option) => (
                        <button
                          key={option.id}
                          type="button"
                          className="flex w-full items-center justify-between gap-2 px-2 py-1 text-left text-xs text-gray-900 hover:bg-gray-100"
                          onMouseDown={(e) => {
                            e.preventDefault();
                            handleCountrySuggestionPick(option);
                          }}
                        >
                          <span className="font-semibold">{option.countryName || option.label}</span>
                          <span className="text-[10px] text-gray-500">
                            {option.isoCode || option.id}
                          </span>
                        </button>
                      ))}
                    </div>
                  )}
                  {!!selectedCountryGeoJSONId && countryGeoJSONSubregionOptions.length > 0 && (
                    <div className="mt-2">
                      <div className="mb-1 text-[10px] font-semibold text-gray-600">
                        USA Subregion
                      </div>
                      <select
                        value={selectedCountryGeoJSONSubregionId}
                        onChange={(e) => {
                          setSelectedCountryGeoJSONSubregionId(e.target.value);
                          applyCountryGeoJSONFilter(selectedCountryGeoJSONId, {
                            subregionId: e.target.value,
                            closeFilter: true,
                          });
                        }}
                        className="w-full rounded-lg border border-gray-200 bg-white px-2 py-2 text-xs text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                        disabled={countryGeoJSONLoading || countryGeoJSONApplying}
                      >
                        {countryGeoJSONSubregionOptions.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  {!countryGeoJSONLoading && !countryGeoJSONApplying && !filteredCountryGeoJSONOptions.length && (
                    <div className="mt-1 text-[10px] text-gray-500">
                      No countries match that search.
                    </div>
                  )}
                  {(countryGeoJSONLoading || countryGeoJSONApplying) && (
                    <div className="mt-1 text-[10px] text-gray-500" aria-live="polite">
                      Loading country data...
                    </div>
                  )}
                  {countryGeoJSONError && (
                    <div className="mt-2 text-[10px] font-semibold text-red-600">
                      {countryGeoJSONError}
                    </div>
                  )}
                  {activeCountryId && (
                    <div className="mt-2 text-[10px] text-gray-500">
                      Country:{' '}
                      {activeCountryOption?.countryName || activeCountryOption?.label || activeCountryId}
                      {activeCountryOption?.isoCode ? ` (${activeCountryOption.isoCode})` : ''}
                      {activeSubregionLabel ? ` • Subregion: ${activeSubregionLabel}` : ''}
                    </div>
                  )}
                  </div>
                  <div
                    className={`rounded-lg bg-gray-50 p-3 transition-opacity duration-150 ${getFilterSectionClass('geojson')}`}
                    onPointerDownCapture={() => setActiveFilterSection('geojson')}
                    onFocusCapture={() => setActiveFilterSection('geojson')}
                  >
                  <div>
                    <div className="mb-2 items-center justify-center">
                      <div className="text-xs font-semibold text-gray-600 mb-2">GeoJSON Boundary</div>
                      <div>
                        <button
                        type="button"
                        className="rounded-md border border-gray-300 px-2 py-1 text-[10px] font-semibold text-gray-700 hover:bg-gray-100"
                        onClick={() => {
                          setShowGeoJSONAdvanced((v) => !v);
                          setGeoJSONFilterError('');
                        }}
                      >
                        Advanced
                      </button>
                      </div>
                    </div>
                    {showGeoJSONAdvanced ? (
                      <>
                        <textarea
                          value={geoJSONFilterText}
                          onChange={(e) => setGeoJSONFilterText(e.target.value)}
                          placeholder='{"type":"Feature","geometry":{"type":"Polygon","coordinates":[[[-121.5,38.5],[-121.3,38.5],[-121.3,38.7],[-121.5,38.7],[-121.5,38.5]]]}}'
                          className="min-h-[120px] w-full rounded-lg border border-gray-200 bg-white px-2 py-2 text-[11px] text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-200"
                          spellCheck={false}
                        />
                        {geoJSONFilterError && (
                          <div className="mt-2 text-[10px] font-semibold text-red-600">
                            {geoJSONFilterError}
                          </div>
                        )}
                        <div className="mt-2 flex justify-end gap-2">
                          <button
                            type="button"
                            className="rounded-lg bg-gray-900 px-3 py-2 text-xs font-semibold text-white hover:bg-gray-800"
                            onClick={applyGeoJSONFilter}
                          >
                            Apply GeoJSON
                          </button>
                          <button
                            type="button"
                            className="rounded-lg bg-gray-200 px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-300"
                            onClick={() => {
                              countryApplyRequestRef.current += 1;
                              setGeoJSONFilterText('');
                              setGeoJSONFilterError('');
                              setCountryGeoJSONApplying(false);
                              setSelectedCountryGeoJSONId('');
                              setCountryGeoJSONSubregionOptions([]);
                              setSelectedCountryGeoJSONSubregionId('');
                              setCountryGeoJSONSearchText('');
                              setCountryGeoJSONError('');
                              props.setGeoJSONCountryFilterId?.('');
                              props.setGeoJSONCountrySubregionId?.('');
                              props.setGeoJSONFilterGeometry?.(null);
                            }}
                          >
                            Clear GeoJSON
                          </button>
                        </div>
                      </>
                    ) : (
                      <div className="text-[10px] text-gray-500">
                        Click Advanced to paste a GeoJSON feature filter.
                      </div>
                    )}
                  </div>
                  {geoJSONCustomActive && geoJSONCustomLabel && (
                    <div className="mt-2 text-[10px] text-gray-500">
                      {geoJSONCustomLabel}
                    </div>
                  )}
                  </div>
                  <div
                    className={`rounded-lg bg-gray-50 p-3 transition-opacity duration-150 ${getFilterSectionClass('reset')}`}
                    onPointerDownCapture={() => setActiveFilterSection('reset')}
                    onFocusCapture={() => setActiveFilterSection('reset')}
                  >
                    <div className="mt-3 flex justify-center gap-2">
                      <button
                        type="button"
                        className="rounded-lg bg-red-600 px-3 py-2 text-xs font-semibold text-white hover:bg-red-500"
                        onClick={() => {
                          resetAllFilters();
                        }}
                      >
                        Reset All Filters
                      </button>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </Transition>
             <Transition
               show={shareOpen}
               as={Fragment}
               enter="transition ease-out duration-200"
               enterFrom="opacity-0 translate-y-1"
               enterTo="opacity-100 translate-y-0"
               leave="transition ease-in duration-150"
               leaveFrom="opacity-100 translate-y-0"
               leaveTo="opacity-0 translate-y-1"
             >
               <div
                 className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${
                   shareOpen ? 'pointer-events-auto' : 'pointer-events-none'
                 }`}
                 onPointerDown={(e) => {
                   if (e.target === e.currentTarget) setShareOpen(false);
                 }}
               >
                 <div
                   className="w-96 max-w-[95vw] overflow-hidden rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/10"
                   onClick={(e) => e.stopPropagation()}
                   onPointerDownCapture={(e) => e.stopPropagation()}
                   onTouchStartCapture={(e) => e.stopPropagation()}
                 >
                   <div className="p-3">
                     <div className="flex items-center justify-between mb-2">
                       <div className="text-xs font-semibold text-gray-600">Share</div>
                       <button
                         type="button"
                         onClick={() => setShareOpen(false)}
                         className="rounded-md p-1 text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                         aria-label="Close"
                       >
                         <XMarkIcon className="h-4 w-4" aria-hidden="true" />
                       </button>
                     </div>
                     <div className="rounded-lg bg-gray-50 p-3">
                      <div className="flex justify-center">
                        {shareValue ? (
                          <div ref={qrContainerRef} className="rounded-md bg-white p-2">
                            <QRCode value={shareValue} size={QR_SIZE} />
                          </div>
                        ) : (
                          <div className="text-xs text-gray-500">Share URL unavailable.</div>
                        )}
                      </div>
                      <QrShareActions
                        shareValue={shareValue}
                        linkText="Share this View"
                        onDownloadSvg={downloadQrSvg}
                        onDownloadPng={downloadQrPng}
                      />
                     </div>
                   </div>
                 </div>
               </div>
             </Transition>
           </>
        </div>
      </div>

      <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto dialog px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="#" className="-m-1.5 p-1.5">
              <span className="sr-only">projectCivilian</span>
              <img className="h-8 w-auto" src="logo.svg" alt="" />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close Menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>

          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <HeaderOptionsCollapsed
                  setMobileMenuOpen={setMobileMenuOpen}
                  getLocation={getLocation}
                  setIsVisiblePaneOpen={props.setIsVisiblePaneOpen}
                  setIsRegisterPaneOpen={props.setIsRegisterPaneOpen}
                  setIsProfilePaneOpen={props.setIsProfilePaneOpen}
                  setIsLoginPaneOpen={props.setIsLoginPaneOpen}
                  setIsPostPaneOpen={props.setIsPostPaneOpen}
                />
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
};

export default Header;
